import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TimelineMax, Power0 } from 'gsap'

import SlideHOC from '../SlideHOC'
import Video from './Video'
import ANIMATION_TYPES from '../../../../constants/animationTypes'

import './VideoScene.scss'

class VideoScene extends Component {

  defineAnimations () {
    this.inAnimation = new TimelineMax({ paused: true })
      .to(this.wrapperRef, 0, { xPercent: 0, rotationY: 0, immediateRender: false })
      .fromTo(this.rootRef, this.props.duration / 2, { autoAlpha: 0, scale: 0.5 },
        { scale: 1, autoAlpha: 1, ease: Power0.easeNone, delay: this.props.duration / 2 })

    this.inReversedAnimation = new TimelineMax({ paused: true })
      .fromTo(this.rootRef, this.props.duration / 2, { autoAlpha: 0, scale: 1 }, { autoAlpha: 1, zIndex: 10 })
      .fromTo(this.wrapperRef, this.props.duration / 2,
        { xPercent: -15, rotationY: 100, immediateRender: false }, { xPercent: 0, rotationY: 0 }, 0)

    this.outAnimation = new TimelineMax({ paused: true })
      .fromTo(this.rootRef, this.props.duration / 2, { zIndex: 1 }, { autoAlpha: 0 })
      .to(this.wrapperRef, this.props.duration / 2, { xPercent: -15, rotationY: 100 }, 0)

    this.outReversedAnimation = this.outAnimation
  }

  render () {
    const { video, title, description, onNext, button } = this.props
    const { currentAnimationType } = this
    return (
      <div className='co_video' ref={ref => (this.rootRef = ref)}>
        <div className='co_video__wrapper' ref={ref => (this.wrapperRef = ref)}>
          <Video
            video={video.url}
            videoBg={video.thumbUrl}
            focused={currentAnimationType === ANIMATION_TYPES.IN || currentAnimationType === ANIMATION_TYPES.IN_REVERSED}
          />

          <div id='co_video__title' className='co_video__title'>
            {title}
          </div>
          <div className='co_video__divider' />
          <div id='co_video__description' className='co_video__description'>
            <span className='co_video__description--text'>{description}</span>
          </div>

          <div className='co_video__button-wrapper'>
            <button id='co_video__button' className='co_video__button' onClick={onNext}>{button}</button>
          </div>
        </div>
      </div>
    )
  }

  static defaultProps = {
    animation: ANIMATION_TYPES.NONE,
    duration: 2,
  }

  static propTypes = {
    video: PropTypes.object,
    title: PropTypes.string,
    button: PropTypes.string,
    description: PropTypes.string,
    onNext: PropTypes.func,
    animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // eslint-disable-line react/no-unused-prop-types
    duration: PropTypes.number,
  }
}

export default SlideHOC(VideoScene)



// WEBPACK FOOTER //
// ./src/templates/coffee/components/video/VideoScene.js